export default __webpack_public_path__ + "static/media/storm-at-sea.b6a95db9.jpg";